// Shared sidebar expand/collapse toggling, so every place that force-opens or
// force-closes the sidebar (NavHeader's menu button, PowerBI report pages, etc.)
// keeps the header logos, footer name/email, and layout offsets all in sync.
import $ from "jquery";

export const expandSidebar = () => {
  const sidenav = document.getElementById("mySidenav");
  const main = document.getElementById("main");
  const navbar = document.getElementById("mainNavbar");
  if (sidenav) {
    sidenav.style.width = "300px";
    sidenav.classList.remove("sidenav-collapsed");
    sidenav.classList.add("sidenav-expanded");
  }
  if (main) main.style.marginLeft = "300px";
  if (navbar) navbar.style.left = "300px";
  $(".item_menuText").show();
  $(".reportLetterBox").css("display", "flex");
  $(".sideNavHeaderLogo").hide();
  $(".sideNavMenu_grid").css("justify-content", "start");
  $(".sideNavMenu").css("overflow-y", "auto");
  $(".userFooterPill").css({ justifyContent: "flex-start", width: "100%" });
  $(".userFooterPill .userNameCol").css("display", "flex");
};

export const collapseSidebar = () => {
  const sidenav = document.getElementById("mySidenav");
  const main = document.getElementById("main");
  const navbar = document.getElementById("mainNavbar");
  if (sidenav) {
    sidenav.style.width = "80px";
    sidenav.classList.add("sidenav-collapsed");
    sidenav.classList.remove("sidenav-expanded");
  }
  if (main) main.style.marginLeft = "80px";
  if (navbar) navbar.style.left = "80px";
  $(".item_menuText").hide();
  $(".reportLetterBox").css("display", "flex");
  $(".sideNavHeaderLogo").show();
  $(".sideNavMenu_grid").css("justify-content", "start");
  $(".sideNavMenu").css("overflow-y", "hidden");
  $(".userFooterPill").css({ justifyContent: "center", width: "fit-content" });
  $(".userFooterPill .userNameCol").css("display", "none");
};
